export default __webpack_public_path__ + "static/media/login-graphic.afbafed1.svg";